import { useState, useEffect } from "react";

import "./App.css";

import Navbar from "./components/Navbar";
import Introduction from "./components/Introduction";
import About from "./components/About";
import Services from "./components/Services";
import Projects from "./components/Projects";
import Archive from "./components/Archive";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import ContactLinks from "./components/ContactLinks";

import Loader from "./components/Loader";

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 4000);
  }, []);

  return (
    <div className="App">
      {isLoading ? (
        <Loader />
      ) : (
        <div className="container-fluid">
          <Navbar />
          <main className="container ">
            <div className="row">
              <Introduction />
              <div className="col-md-10 offset-md-1">
                <About />
                <Services />
                <Projects />
                <Archive />
                <Contact />
                <Footer />
              </div>
            </div>
          </main>
          <ContactLinks />
        </div>
      )}
    </div>
  );
}

export default App;
